export default "__VITE_ASSET__B0S$0xNG__"